import s from "./index18.js";
import { openBlock as t, createElementBlock as i, normalizeClass as l, createElementVNode as r, withModifiers as n } from "vue";
import "./index19.js";
import d from "../../../../_virtual/index.js";
const m = { class: "logo-link" }, p = ["aria-label"];
function c(e, o, f, _, g, u) {
  return t(), i("div", {
    class: l(e.logoClass.logoClass)
  }, [
    r("div", m, [
      r("a", {
        href: "/",
        "aria-label": e.sitebrand,
        onClick: o[0] || (o[0] = n((...a) => e.redirectToHomePage && e.redirectToHomePage(...a), ["prevent"]))
      }, null, 8, p)
    ])
  ], 2);
}
const $ = /* @__PURE__ */ d(s, [["render", c], ["__scopeId", "data-v-dab98363"]]);
export {
  $ as default
};
//# sourceMappingURL=index10.js.map
